import { GatsbyImage, type GatsbyImageProps } from 'gatsby-plugin-image';

import { imageAssetToGatsbyImageData } from 'utils/contentful/imageAssetToGatsbyImageData';
import type { ImageAsset } from 'schema';

type ContentfulImageProps = Omit<GatsbyImageProps, 'image' | 'alt'> & {
  image: ImageAsset;
  alt?: string;
  loading?: 'lazy' | 'eager';
  fetchPriority?: 'high' | 'low' | 'auto';
};

export const ContentfulImage = ({
  image,
  alt,
  loading,
  fetchPriority,
  ...props
}: ContentfulImageProps) => (
  <GatsbyImage
    alt={alt ?? image.title}
    image={imageAssetToGatsbyImageData(image)}
    loading={loading}
    {...props}
    {...(fetchPriority && ({ fetchpriority: fetchPriority } as any))}
  />
);
